import ClientPortalDashboardChart from './ClientPortalDashboardChart';

export default ClientPortalDashboardChart;
